import React from "react"
import { Button } from "@/components/ui/button"
import { X } from "lucide-react"

interface ActiveFiltersProps {
  focusArea: string[]
  beneficiaryType: string[]
  format: string[]
  location?: string
  onRemove: (filterType: string, value: string) => void
  onClearAll: () => void
}

export const ActiveFilters: React.FC<ActiveFiltersProps> = ({
  focusArea,
  beneficiaryType,
  format,
  location,
  onRemove,
  onClearAll,
}) => {
  const hasActiveFilters = focusArea.length > 0 || beneficiaryType.length > 0 || format.length > 0 || location;

  if (!hasActiveFilters) {
    return null;
  }

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-medium">Active Filters</h3>
        {hasActiveFilters && (
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={onClearAll}
            className="text-xs text-muted-foreground hover:text-foreground"
          >
            Clear all
          </Button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {focusArea.map((area) => (
          <div key={area} className="flex items-center gap-1 bg-blue-50 text-blue-700 px-2 py-1 rounded-full text-xs">
            <span>{area.replace('_', ' & ')}</span>
            <Button 
              variant="ghost" 
              size="icon" 
              className="h-4 w-4 p-0" 
              onClick={() => onRemove("focusArea", area)}
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
        ))}
        {beneficiaryType.map((type) => (
          <div key={type} className="flex items-center gap-1 bg-green-50 text-green-700 px-2 py-1 rounded-full text-xs">
            <span>{type}</span>
            <Button 
              variant="ghost" 
              size="icon" 
              className="h-4 w-4 p-0" 
              onClick={() => onRemove("beneficiaryType", type)}
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
        ))}
        {format.map((fmt) => (
          <div key={fmt} className="flex items-center gap-1 bg-purple-50 text-purple-700 px-2 py-1 rounded-full text-xs">
            <span>{fmt.replace('_', ' ')}</span>
            <Button 
              variant="ghost" 
              size="icon" 
              className="h-4 w-4 p-0" 
              onClick={() => onRemove("format", fmt)}
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
        ))}
        {location && (
          <div className="flex items-center gap-1 bg-amber-50 text-amber-700 px-2 py-1 rounded-full text-xs">
            <span>Location: {location}</span>
            <Button 
              variant="ghost" 
              size="icon" 
              className="h-4 w-4 p-0" 
              onClick={() => onRemove("location", location)}
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
